import { useEffect, useState } from "react";
import "../assets/styles/views/navigate-as.scss";
import { useLocation, useOutletContext } from "react-router-dom";
import { districts_list, get_pv_list, rcr_area } from "../utils/endpoints";
import { getCookie } from "../utils/cookie";
import { setCookie } from "../utils/cookie";
import BackArrowButton from "../components/BackArrowButton";

export default function NavigateAs() {
  const [context, setContext] = useOutletContext();
  const [districts, setDistricts] = useState();
  const [selected_district, setSelectedDistrict] = useState();
  const [cavr, setCavr] = useState();
  const [selected_cavr, setSelectedCavr] = useState();
  const [rcr, setRcr] = useState();
  const [selected_rcr, setSelectedRcr] = useState();
  const [pv, setPv] = useState();
  const [selected_pv, setSelectedPv] = useState();
  const [initial_load, setInitialLoad] = useState(true);
  const [role, setRole] = useState();

  const location = useLocation();

  const getHierarchy = async (id) => {
    const response = await context.httpRequest(
      "get",
      rcr_area.replace("*", id),
      null,
      context.session.token
    );
    return response;
  };

  const loadDistricts = async () => {
    let response = await context.httpRequest(
      "get",
      districts_list,
      null,
      context.session.token
    );
    if (response.result) {
      if (location.state && initial_load) {
        let last_district_selected = response.data.find(
          (x) => x.codice === location.state.pv.codiceDistrict
        ).id;
        setSelectedDistrict(last_district_selected);
      }
      return response.data;
    }
    return response;
  };

  useEffect(() => {
    if (role) {
      (async () => {
        if (role == "ADMIN") {
          let districts = await loadDistricts();
          if (districts) {
            setDistricts(districts);
          }
        }
      })();
    }
  }, [role]);

  useEffect(() => {
    if (!!context.session) {
      setRole(context.session.profileTypeCode);
    }
  }, [context.session]);

  useEffect(() => {
    setCavr();
    setRcr();
    setSelectedCavr("");
    setSelectedRcr("");
    if (selected_district) {
      (async () => {
        const response = await getHierarchy(selected_district);
        if (response.result) {
          setCavr(response.data);
          if (location.state && initial_load) {
            let last_cavr_selected = response.data.find(
              (x) => x.codice === location.state.pv.codiceArea
            ).id;
            setSelectedCavr(last_cavr_selected);
          }
        }
      })();
    }
  }, [selected_district]);

  useEffect(() => {
    setRcr();
    setSelectedRcr("");
    if (selected_cavr) {
      (async () => {
        const response = await getHierarchy(selected_cavr);
        if (response.result) {
          setRcr(response.data);
          if (location.state && initial_load) {
            let last_rcr_selected = response.data.find(
              (x) => x.codice === location.state.pv.loginRcr
            ).id;
            setSelectedRcr(last_rcr_selected);
            setInitialLoad(false);
          }
        }
      })();
    }
  }, [selected_cavr]);

  useEffect(() => {
    setPv();
    setSelectedPv("");
    if (selected_rcr) {
      (async () => {
        const response = await context.httpRequest(
          "get",
          get_pv_list.replace("*", selected_rcr),
          null,
          context.session.token
        );
        if (response.result) setPv(response.data);
      })();
    }
  }, [selected_rcr]);

  const handleImpersonate = async () => {
    setCookie("pv_impersonate", selected_pv);
    window.location.href = "/";
  };

  return (
    <>
      <BackArrowButton path="/" />
      <section className="navigate-as w-100 flex-md-wrap px-md-3 d-flex">
        <h1 className="navigate-as__title px-3 mt-3 mt-md-4 mb-3 text-start text-md-center">
          Impersonifica utente
        </h1>
        <div className="navigate-as__filters-container position-sticky p-3 mx-3 mb-3 mx-md-auto border shadow-sm">
          <label>DISTRETTO</label>
          <select
            name="districts"
            onChange={(e) => setSelectedDistrict(e.target.value)}
            className="w-100 mb-3"
            required
            value={selected_district}
          >
            <option value="">Seleziona..</option>
            {districts
              ? districts.map((item, index) => {
                  return (
                    <option value={item.id} key={index}>
                      {item.nome}
                    </option>
                  );
                })
              : null}
          </select>

          <label>CAVR</label>
          <select
            disabled={!!selected_district ? false : true}
            name="cavr"
            onChange={(e) => setSelectedCavr(e.target.value)}
            className="w-100 mb-3"
            required
            value={selected_cavr}
          >
            <option value="">Seleziona..</option>
            {cavr
              ? cavr.map((item, index) => {
                  return (
                    <option value={item.id} key={index}>
                      {item.type} {item.nome}
                    </option>
                  );
                })
              : null}
          </select>

          <label>RCR</label>
          <select
            disabled={!!selected_cavr ? false : true}
            name="rcr"
            onChange={(e) => setSelectedRcr(e.target.value)}
            className="w-100 mb-3"
            required
            value={selected_rcr}
          >
            <option value="">Seleziona..</option>
            {rcr
              ? rcr.map((item, index) => {
                  return (
                    <option value={item.id} key={index}>
                      {item.rcrCognome} {item.rcrNome}
                    </option>
                  );
                })
              : null}
          </select>

          <label>Punti vendita</label>
          <select
            disabled={!!selected_cavr ? false : true}
            name="pv"
            onChange={(e) => setSelectedPv(e.target.value)}
            className="w-100"
            required
            value={selected_pv}
          >
            <option value="">Seleziona..</option>
            {pv
              ? pv.map((item, index) => {
                  return (
                    <option value={item.pv.codicePv} key={index}>
                      {item.pv.codicePv} -{" "}
                      {`${item.pv.indirizzo}, ${item.pv.comune} (${item.pv.prov})`}
                    </option>
                  );
                })
              : null}
          </select>
          {selected_pv ? (
            <button
              onClick={() => handleImpersonate()}
              className="q8-blue-button p-3 w-100 mt-4"
            >
              IMPERSONIFICA
            </button>
          ) : null}
        </div>
      </section>
    </>
  );
}
